import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Radio, Typography } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import TuneIcon from "@mui/icons-material/Tune";
import Button from "@mui/material/Button";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@material-ui/core/styles";
import { findIndex, map } from "lodash";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import { getFormatedTimeOnly } from "../../Js/TimeAndDate";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const filterByDays = [
  { value: 30, label: "1 Month" },
  { value: 90, label: "3 Month" },
  { value: 180, label: "6 Month" },
  { value: 365, label: "1 Year" },
  { value: 0, label: "All" },
];
const WWAdminBoxMonthly = (props) => {
  const classes = useStyles();
  let [startDate, setStartDate] = useState(null);
  let [endDate, setEndDate] = useState(null);
  let [date, setDate] = useState(null);
  let [month, setMonth] = useState(null);
  let [year, setYear] = useState(null);

  let [date2, setDate2] = useState(null);
  let [month2, setMonth2] = useState(null);
  let [year2, setYear2] = useState(null);
  let [minDate, setMinDate] = useState(null);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  // State

  const handleChange = (date) => {
    let d = moment(date);
    setDate(d.date());
    setMonth(d.month());
    setYear(d.year());
    setMinDate(date);
    setStartDate(date);
  };

  const handleChange2 = (date) => {
    let d = moment(date);
    setDate2(d.date());
    setMonth2(d.month());
    setYear2(d.year());
    setEndDate(date);
  };

  const openReport = () => {
    if (month2 && year2 && date2) {
      window.open(
        `${process.env.REACT_APP_SERVER_API}/MonthlyReport/${userInfo.site_uuid}/${date}/${month}/${year}/${date2}/${month2}/${year2}`,
        "_blank"
      );
    } else {
      window.open(
        `${process.env.REACT_APP_SERVER_API}/MonthlyReport/${userInfo.site_uuid}/${date}/${month}/${year}`,
        "_blank"
      );
    }
  };
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          mt: 3,
          mx: 1,
          my: 1,
          background:
            "linear-gradient(to right, #fcfcfc 0%,#f5f7ff 43%,#edf0ff 100%);",
          borderRadius: 5,
          boxShadow: "3px 3px 5px 1px #dddddd",
          "@media (min-width: 1636px)": { mx: 3 },
        }}
      >
        <List sx={{ p: 0, m: 0 }}>
          <ListItem sx={{ p: 0 }} disablePadding>
            <ListItemButton sx={{ borderRadius: 4, p: 4 }}>
              <ListItemText
                sx={{ m: 0, px: 0 }}
                primary={
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#5f5600ff",
                      fontWeight: "800",
                      fontSize: "1.8rem",
                      "@media (min-width: 1636px)": { fontSize: "2.6rem" },
                    }}
                  >
                    Monthly/Yearly Report
                  </Typography>
                }
              />
            </ListItemButton>
            <Grid xs={4}>
              <LocalizationProvider dateAdapter={AdapterMoment} def>
                <FormControl
                  fullWidth
                  sx={{
                    mx: 1,
                    mb: 1,
                    borderRadius: 2,
                    borderColor: "#FFFFFF",
                    backgroundColor: "#F5F5F5",
                    color: "#D9D9D9",
                  }}
                  size="small"
                >
                  <DatePicker
                    label={'start date'}
                    //views={["month", "year"]}
                    onChange={handleChange}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
            <Grid xs={4} ml={1}>
              <LocalizationProvider dateAdapter={AdapterMoment} def>
                <FormControl
                  fullWidth
                  sx={{
                    mx: 1,
                    mb: 1,
                    borderRadius: 2,
                    borderColor: "#FFFFFF",
                    backgroundColor: "#F5F5F5",
                    color: "#D9D9D9",
                  }}
                  size="small"
                >
                  <DatePicker
                    label={'end date'}
                    //views={["month", "year"]}
                    onChange={handleChange2}
                    minDate={minDate}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
            <Grid xs={2} textAlign={"center"}>
              {month != null && year != null && (
                <Button
                  sx={{
                    backgroundColor: "primary.main",
                    color: "#FFFFFF",
                    textTransform: "inherit",
                    borderRadius: 10,
                    fontWeight: "600",
                    mx: 1,
                   
                    "@media (min-width: 1636px)": { fontSize: "1.2rem", px: 2 },
                  }}
                  size="large"
                  onClick={openReport}
                  disabled={new Date(startDate) > new Date(endDate)}
                >
                  GO
                </Button>
              )}
            </Grid>
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  image: {
    "@media (min-width: 1636px)": {
      width: "14rem",
    },
  },
});
export default WWAdminBoxMonthly;
